// React
import React from "react"

// Components
import EventCard from "./EventCard"

// Material ui
import { Container, Grid, Typography } from "@mui/material"

function createEventGridItems(events) {
  return (events || []).map(
    ({
      slug,
      title,
      summary,
      startTime,
      endTime,
      destinationUrl,
      subtitle,
    }) => ({
      slug,
      title,
      summary,
      startTime,
      endTime,
      destinationUrl,
      subtitle,
    })
  )
}

export default function EventsGrid(props) {
  const { events } = props
  const { topGutterSpacing, bottomGutterSpacing } = props

  const eventGridItems = createEventGridItems(events)

  return (
    <Container
      sx={{
        marginTop: topGutterSpacing || 0,
        marginBottom: bottomGutterSpacing || 0,
      }}
      maxWidth="lg"
    >
      <Typography
        sx={{
          marginLeft: 2,
          marginBottom: 2,
        }}
      >
        UP NEXT:
      </Typography>
      <Grid container spacing={4} alignItems="stretch">
        {eventGridItems.map((event) => (
          <Grid item xs={12} sm={6} md={4} key={event.title}>
            <EventCard {...event} />
          </Grid>
        ))}
      </Grid>
    </Container>
  )
}
